import SplitMultiSelectInput from "../split.multi.select.input";
import CopyButton from "../../../../buttons/copy.button";

const TicketShipmentMultiSelectInput = ({
  selectedTickets,
  formFields: { tickets, from, to, customer_id },
  contacts,
  handleMultiSelectChange,
  label,
  handleCopyCustomer = () => {},
  handleCopyContact = () => {},
}) => {
  // Helper: safely match a contact to its corresponding customer field
  const getCustomerField = (selectedTickets, contact, field) => {
    const match = selectedTickets.find(
      (t) =>
        // Primary match: ticket’s invoice_contacts include this contact
        t?.invoice_contacts?.some((ic) => ic?.id === contact?.id) ||
        // Fallback: ticket’s direct contact matches (for tickets with no invoice_contacts)
        (!t?.invoice_contacts?.length && t?.contact?.id === contact?.id)
    );
    return match ? match[field] : "";
  };

  // 🧹 Merge and dedupe contact list (handles cases where contact may appear in multiple tickets)
  const mergedContacts = [
    ...(Array.isArray(contacts) ? contacts : []),
    ...selectedTickets
      .filter(
        (t) =>
          (!Array.isArray(t.invoice_contacts) ||
            t.invoice_contacts.length === 0) &&
          t.contact &&
          t.contact.id
      )
      .map((t) => ({
        ...t.contact,
        customer_id: t.customer_id,
      })),
  ];

  const allContacts = mergedContacts.filter(
    (contact, index, self) =>
      index ===
      self.findIndex(
        (c) =>
          +c.id === +contact.id &&
          +c.customer_id === +contact.customer_id
      )
  );

  return (
    <div className="w-full">
      <label className="text-secondary capitalize font-ubuntuBold flex justify-start">
        {label}
      </label>
      <SplitMultiSelectInput
        name={"tickets"}
        displayField={"number"}
        value={tickets}
        handleChange={handleMultiSelectChange}
        linkOptions={{
          href: "https://techcyclesolutions.repairshopr.com/tickets",
          active: true,
          identifier: "id",
          target: "_blank",
        }}
      >

        {allContacts
          ?.filter((contact) => {
            if (!tickets.length) return true;
            else if (
              (!to.contact_id || !from.contact_id) &&
              +customer_id === +contact.customer_id
            ) {
              return tickets[0]?.contact_id
                ? contact.id === +tickets[0].contact_id
                : true;
            } else {
              return (
                contact.id === from.contact_id || contact.id === to.contact_id
              );
            }
          })
          ?.map((contact) => (
            <div key={contact?.id}>
              <div className="flex items-center justify-start bg-slate-200 p-2 rounded shadow gap-2">
                <div className="flex flex-row items-center gap-2">
                  <span className="font-bold">
                    {getCustomerField(
                      selectedTickets,
                      contact,
                      "customer_business_then_name"
                    )}
                  </span>
                  <CopyButton
                    handleClick={(e) => {
                      e.preventDefault();
                      handleCopyCustomer(
                        getCustomerField(
                          selectedTickets,
                          contact,
                          "customer_id"
                        ),
                        contact?.id
                      );
                    }}
                  />
                </div>
                |
                <div className="flex flex-row items-center gap-2">
                  <span className="font-bold">{contact?.name}</span>
                  <CopyButton
                    handleClick={(e) => {
                      e.preventDefault();
                      handleCopyContact(contact?.id);
                    }}
                  />
                  :
                </div>
                <span className="flex">
                  {contact?.address1} {contact?.city}, {contact?.state}{" "}
                  {contact?.zip}
                </span>
              </div>

              {selectedTickets
                ?.filter(
                  (ticket) =>
                    ticket?.invoice_contacts?.some(
                      (c) => c?.id === contact.id
                    ) ||
                    (!ticket?.invoice_contacts?.length &&
                      ticket?.contact?.id === contact.id)
                )
                ?.map((ticket) => (
                  <div
                    data-customer_business_then_name={
                      ticket.customer_business_then_name
                    }
                    data-contact_id={contact.id}
                    data-name={"tickets"}
                    data-number={ticket.number}
                    data-id={ticket.id}
                    data-customer_id={ticket.customer_id}
                    onClick={handleMultiSelectChange}
                    key={ticket.id}
                    className={`${
                      tickets?.find((v) => v?.id === ticket?.id)
                        ? "bg-secondary text-white"
                        : "bg-white"
                    } shadow m-1 cursor-pointer hover:bg-primary hover:text-secondary rounded px-2 py-1`}
                  >
                    {ticket?.number}
                  </div>
                ))}
            </div>
          ))}
      </SplitMultiSelectInput>
    </div>
  );
};

export default TicketShipmentMultiSelectInput;
